import React, { useEffect, useState } from 'react';
import PanelShell from '../PanelShell';

const XorPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [a, setA] = useState(data?.a || '');
  const [b, setB] = useState(data?.b || '');
  useEffect(()=>{ setA(data?.a || ''); setB(data?.b || ''); }, [data]);
  if (nodeType !== 'Xor') return null;
  const save=()=> onChange({ label:'Xor', a, b, Title:`XOR(${a}, ${b})` });
  return (
    <PanelShell title="XOR" onSave={save}>
      <label>A</label>
      <input value={a} onChange={e=>setA(e.target.value)} />
      <label>B</label>
      <input value={b} onChange={e=>setB(e.target.value)} />
    </PanelShell>
  );
};
export default XorPanel;
